import {
  QBankStructureValidationCase,
  type ValidateQBankStructureResult,
} from '@exam-management/graphql';
import { Button, DialogActions, DialogContent, Flex, Text } from '@shared/components';

import ValidationResultContent from './validation-result-content';

const contentByValidationCase: Record<
  QBankStructureValidationCase,
  {
    title: string;
    highlightText: string;
  }
> = {
  [QBankStructureValidationCase.MissingNameInInformationItem]: {
    title: 'รายการโครงสร้างที่ยังไม่เสร็จเรียบร้อย กรุณา “ระบุชื่อโครงสร้าง” หรือตั้งค่า “ไม่มี”',
    highlightText: 'ไม่เสร็จเรียบร้อย',
  },
  [QBankStructureValidationCase.MissingLastLevelItem]: {
    title: 'รายการโครงสร้างที่ยังสร้างไม่ถึงระดับหัวข้อย่อย กรุณาสร้างให้เสร็จ',
    highlightText: 'สร้างไม่ถึงระดับหัวข้อย่อย',
  },
};

interface ValidationSectionProps {
  loading?: boolean;
  results: Partial<ValidateQBankStructureResult>[];
  onClose: () => void;
  onNext: () => void;
}

export default function ValidationSection(props: Readonly<ValidationSectionProps>) {
  const { loading: isLoading = false, results, onClose, onNext } = props;

  const isGoNextDisabled = isLoading || results.some((result) => result.passed === false);

  return (
    <>
      <DialogContent>
        <Flex
          sx={{
            flexDirection: 'column',
            gap: (theme) => theme.spacing(2),
          }}
        >
          <Text variant='h5'>ตรวจสอบโครงสร้างเบื้องต้น</Text>
          {results.map((result) => {
            const { case: validationCase } = result;
            if (!validationCase) return null;
            const { title, highlightText } = contentByValidationCase[validationCase];
            const issuedQIds = [] as string[];

            return (
              <ValidationResultContent
                key={validationCase}
                title={title}
                highlightText={highlightText}
                issuedQIds={issuedQIds}
                loading={isLoading}
              />
            );
          })}
        </Flex>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          disabled={isLoading}
          onClick={onClose}
          color='secondary'
          size='large'
        >
          ยกเลิก
        </Button>
        <Button disabled={isGoNextDisabled} onClick={onNext} size='large'>
          ถัดไป
        </Button>
      </DialogActions>
    </>
  );
}
